import React from "react";
import { Card } from "../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { EMOTIONS, EMOTION_LABELS_TR, EMOTION_EMOJI, EMOTION_COLORS } from "../lib/constants";
import { PolarityBadge, WarStanceBadge } from "./StanceBadge";

export default function ComparisonTable({ data }) {
  if (!data) return null;
  const { rows = [], extremes = {} } = data;

  function cellStyle(emotion, value) {
    const ex = extremes[emotion] || { min: 0, max: 100 };
    if (ex.max !== ex.min && value === ex.max) {
      return { color: "#FCA5A5", background: "rgba(239,68,68,0.18)", fontWeight: 700 };
    }
    if (ex.max !== ex.min && value === ex.min) {
      return { color: "#86EFAC", background: "rgba(34,197,94,0.14)", fontWeight: 700 };
    }
    return {};
  }

  return (
    <Card className="rounded-sm bg-[#141414] border-white/10 overflow-hidden" data-testid="comparison-table">
      <div className="p-3 border-b border-white/10 flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="data-label">Karşılaştırma Matrisi (Dönem Ortalamaları)</div>
          <div className="text-white font-heading text-base">12 Ülke Girişi × 6 Duygu Boyutu</div>
        </div>
        <div className="text-[11px] font-mono text-gray-400 flex gap-3">
          <span><span className="inline-block w-2 h-2 bg-red-500/60 mr-1" /> En yüksek</span>
          <span><span className="inline-block w-2 h-2 bg-green-500/60 mr-1" /> En düşük</span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-white/10 hover:bg-transparent">
              <TableHead className="text-gray-400 font-mono uppercase text-[10px] tracking-[0.18em]">Ülke</TableHead>
              <TableHead className="text-gray-400 font-mono uppercase text-[10px] tracking-[0.18em]">Polarite</TableHead>
              <TableHead className="text-gray-400 font-mono uppercase text-[10px] tracking-[0.18em]">Tutum</TableHead>
              {EMOTIONS.map((e) => (
                <TableHead key={e}
                           className="font-mono uppercase text-[10px] tracking-[0.18em] text-center"
                           style={{ color: EMOTION_COLORS[e] }}>
                  {EMOTION_EMOJI[e]} {EMOTION_LABELS_TR[e]}
                </TableHead>
              ))}
              <TableHead className="text-gray-400 font-mono uppercase text-[10px] tracking-[0.18em] text-center">N</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.code} className="border-white/5 hover:bg-white/[0.03]"
                        data-testid={`comparison-row-${r.code}`}>
                <TableCell className="font-mono text-sm">
                  <div className="flex items-center gap-2">
                    <img src={r.flag_url} alt="" className="h-4 w-6 object-cover rounded-sm border border-white/10" />
                    <span className="text-white">{r.name_tr}</span>
                  </div>
                </TableCell>
                <TableCell><PolarityBadge polarity={r.polarity} /></TableCell>
                <TableCell><WarStanceBadge stance={r.war_stance} /></TableCell>
                {EMOTIONS.map((e) => (
                  <TableCell key={e} className="text-center font-mono text-sm"
                             style={cellStyle(e, r.emotions?.[e] ?? 0)}
                             data-testid={`comparison-${r.code}-${e}`}>
                    {r.emotions?.[e] ?? 0}
                  </TableCell>
                ))}
                <TableCell className="text-center font-mono text-xs text-gray-400">{r.count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
